var render = function render(){var _vm=this,_c=_vm._self._c;return _c('labo-form',{attrs:{"labo":_vm.labo,"loading":_vm.loading,"disabled":_vm.disabled,"config":_vm.config,"parameter-options":_vm.parameterOptions},on:{"update-labo":function($event){_vm.labo = $event},"change-config":function($event){_vm.config = $event}}})
}
var staticRenderFns = []

export { render, staticRenderFns }